const getPluralityCharacter = (value: number): string => {
    return value == 1
        ? ''
        : 's'
}

const encodeNameForURI = (name: string): string => {
    return encodeURI(name.split(" ").join("+"));
}

const decodeNameFromURI = (name: string): string => {
    name = name.split("_").join("+");
    return decodeURI(name.split("+").join(" "));
}

const generateCryptoString = (length: number) => {
    const charset = '0123456789ABCDEFGHIJKLMNOPQRSTUVXYZabcdefghijklmnopqrstuvwxyz'
    let result = ''

    while (length > 0) {
        var bytes = new Uint8Array(16);
        var random = window.crypto.getRandomValues(bytes);

        for (let character of random) {
            if (length == 0) {
                break;
            }
            if (character < charset.length) {
                result += charset[character];
                length--;
            }
        }
    }
    return result;
}

export const STRING_UTILS = {
    getPluralityCharacter,
    encodeNameForURI,
    decodeNameFromURI,
    generateCryptoString,
}